import React from 'react';
import styles from 'components/animatedImg/animatedIng.module.css';
import { useIntersectionObserver } from 'hooks/useInterspectionObserver';

interface IAnimatedImg {
    children: JSX.Element;
}
export const AnimatedImg = ({ children }: IAnimatedImg) => {
    const { ref, isVisible } = useIntersectionObserver();

    return (
        <div
            ref={ref}
            className={`${styles.img} ${isVisible ? styles.inView : ''}`}
        >
            {children}
        </div>
    );
};
